(function() {
'use strict';

angular
    .module('TR')
    .controller('TestHome', TestHome);

function TestHome() {
    const cm = this;

    cm.activeTabId = 'aaa';


    cm.dialogOpen = false;

    cm.dialogTwoOpen = false;

}
})();
